import { SplashScreen } from '@capacitor/splash-screen'

// 设置开始画面
export const splash = {
    show(options) { SplashScreen.show(options) },
    hide(options) { SplashScreen.hide(options) },
}